import type {
  CompletedPayrollRosterTechnicianSync,
  PayrollRoster,
} from "@/payroll/roster/types";

export const replacePayrollRosterSuggestions = (
  current: PayrollRoster | null | undefined,
  synced: CompletedPayrollRosterTechnicianSync,
) =>
  current
    ? {
        ...current,
        missing_user_suggestions: synced.missing_user_suggestions,
        departed_member_ids: synced.departed_member_ids,
      }
    : current;

export const buildWorkingRosterCacheEntry = (
  saved: PayrollRoster,
  current?: PayrollRoster | null,
): PayrollRoster => ({
  ...current,
  ...saved,
  is_draft: true,
});

export const buildDiscardedRosterCacheEntry = (
  current?: PayrollRoster | null,
): PayrollRoster | null | undefined => {
  if (!current) return current;
  if (!current.baseline) return null;

  return {
    ...current,
    version_number: current.baseline.version_number,
    status: "published",
    published_at: current.baseline.published_at,
    is_draft: false,
    fields: current.baseline.fields,
    members: current.baseline.members,
    removed_member_external_ids: current.baseline.removed_member_external_ids,
  };
};

export const buildPublishedRosterCacheEntry = (
  published: PayrollRoster,
  current?: PayrollRoster | null,
): PayrollRoster => ({
  ...current,
  ...published,
  is_draft: false,
  baseline: {
    version_number: published.version_number,
    published_at: published.published_at,
    fields: published.fields,
    members: published.members,
    removed_member_external_ids: published.removed_member_external_ids,
  },
});
